export async function downloadFile(file: Blob, fileName: string) {
    let url = window.URL.createObjectURL(file);
    let a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
}